export class QuantityInfoModel {
  public quantity: number;
  public fixedQuantity: boolean;

  constructor(params: QuantityInfoModel) {
    this.quantity = params.quantity;
    this.fixedQuantity = params.fixedQuantity;
  }

  public static fromCheckoutV1(
    confirmedQuantity: number,
    fixedQuantity?: boolean | null,
    hideQuantity?: boolean | null
  ) {
    return new QuantityInfoModel({
      quantity: confirmedQuantity,
      fixedQuantity: (hideQuantity || fixedQuantity) ?? false,
    });
  }
}
